
import { Component, Prop, Vue } from 'vue-property-decorator';
// import { UserModule } from '@/store/modules/user';
import PickerAddress from '@/components/PickAddressInMap/index.vue';
import { UserModule } from '@/store/modules/user';
import { getCustomerList, addUserToCustomer, getCustomerDetail } from '@/api/customer';
import { checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';

@Component({
  name: 'CustomerAddedFrom',
  components: {
    PickerAddress
  }
})
export default class extends Vue {
  private customerCreateForm: any = {
    customerType: '',
    addType: '',
    customer: '',
    name: '',
    manager: '',
    mobile: '',
    telephone: '',
    area: '',
    address: '',
    agent: '',
    province: '',
    provinceName: '',
    city: '',
    cityName: '',
    district: '',
    districtName: '',
    latitude: '',
    longitude: '',
    first: '',
    sales_rep: ''
  }
  private listLoading=false
  private dataTable: any = []
  private orderDetail:any=''
  created() {
    this.orderDetail = JSON.parse(this.$route.query.orderDetail as string);
    this.isShowCustomerHistry = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.CustomerHistry);
  }

  private customerTypeChange(val:any) {
    if (parseInt(val) === 2) {
      this.getCustomerList();
    }
  }
  private getCustomerList() {
    this.listLoading = true;
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      page: this.listQuery.page,
      size: this.listQuery.size,
      contain_branch: 1
    };
    params.only_id = this.listQuery.onlyId;
    params.customer_name = this.listQuery.name;
    params.customer_type = 1;
    getCustomerList(params)
      .then((res: any) => {
        const data = res.data;
        if (data !== null) {
          this.listQuery.count = parseInt(data.count);
          this.dataTable = data.list;
        } else {
          this.listQuery.page = 1;
          this.listQuery.count = 0;
          this.dataTable = [];
        }
        this.listLoading = false;
      })
      .catch((err: any) => {
        this.listQuery.page = 1;
        this.listQuery.count = 0;
        this.dataTable = [];
        this.listLoading = false;
        let msg = err.msg;
      });
  }
  private listQuery: any = {
    page: 1,
    size: 10,
    count: 0
  }
  private showAddressDialog = false

  private areaCilck() {
    this.showAddressDialog = true;
  }
  // 地图dialog 保存 回调
  private positionPicker(address: any) {
    if (address) {
      this.customerCreateForm.provinceName = address.province_name;
      this.customerCreateForm.province = address.province;
      this.customerCreateForm.cityName = address.city_name;
      this.customerCreateForm.city = address.city;
      this.customerCreateForm.districtName = address.district_name;
      this.customerCreateForm.district = address.district;
      this.customerCreateForm.latitude = address.latitude;
      this.customerCreateForm.longitude = address.longitude;
      this.customerCreateForm.area = address.province_name + '  ' + address.city_name + '  ' + address.district_name;
      this.customerCreateForm.address = address.address;
    }
  }
  // 地图dialog 关闭
  private closeAddress(close: boolean) {
    this.showAddressDialog = close;
  }
  private addCustomer() {
    let pamars:any = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_id: UserModule.getUserId
    };
    pamars.customer_user_id = this.orderDetail.order.customer_user_id;
    if (this.customerCreateForm.customerType === '2') {
      pamars.add_type = 2;
    } else if (this.customerCreateForm.addType !== '2') {
      if (!this.customerCreateForm.addType) {
        this.showErrorMsg('请选择添加方式');
        return;
      }
      pamars.add_type = 3;
      pamars.name = this.customerCreateForm.name;
      pamars.manager = this.customerCreateForm.manager;
      pamars.mobile = this.customerCreateForm.mobile;
      pamars.phone = this.customerCreateForm.telephone;
      pamars.provinceName = this.customerCreateForm.provinceName;
      pamars.province = this.customerCreateForm.province;
      pamars.cityName = this.customerCreateForm.cityName;
      pamars.city = this.customerCreateForm.city;
      pamars.districtName = this.customerCreateForm.districtName;
      pamars.district = this.customerCreateForm.district;
      pamars.adcode = this.customerCreateForm.adcode;
      pamars.latitude = this.customerCreateForm.latitude;
      pamars.longitude = this.customerCreateForm.longitude;
      pamars.address = this.customerCreateForm.address;
      pamars.vip_customer = this.customerCreateForm.first ? '1' : '0';
      pamars.sales_rep = this.customerCreateForm.sales_rep;
      pamars.agent = this.customerCreateForm.agent;

      // if (this.formAddCustomer.tag1 && this.formAddCustomer.tag1.id) {
      //   pamars.customer_tag_pname = this.formAddCustomer.tag1.name;
      //   pamars.customer_tag_pid = this.formAddCustomer.tag1.id;
      // }
      // if (this.formAddCustomer.tag2 && this.formAddCustomer.tag2.id) {
      //   pamars.customer_tag_name = this.formAddCustomer.tag2.name;
      //   pamars.customer_tag_id = this.formAddCustomer.tag2.id;
      // }
    } else {
      pamars.add_type = 1;
      if (!this.customerCreateForm.customer || !this.customerCreateForm.customer.customer_company_id) {
        this.showErrorMsg('请选择客户');
        return;
      }
      pamars.customer_company_id = this.customerCreateForm.customer.customer_company_id;
    }
    addUserToCustomer(pamars).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.$router.go(-1);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private searchTable() {
    this.listQuery.page = 1;
    this.getCustomerList();
  }
  private emptySearchTable() {
    this.listQuery = {
      page: 1,
      size: 10,
      count: 0
    };
    this.getCustomerList();
  }
  private handleSizeChange(val:number) {
    this.listQuery.size = val;
    this.getCustomerList();
  }
  private handleCurrentChange(val:number) {
    this.listQuery.page = val;
    this.getCustomerList();
  }
  // 客户详情
  private dialogCustomerDetailVisible = false
  private detailActiveName = 'first'
  private detailCustomer:any=''
  private isShowCustomerHistry=false;

  private detailHandle(val:any) {
    this.dialogCustomerDetailVisible = true;
    this.getCustomerDetail(val.id);
  }
  private getCustomerDetail(customerId:string) {
    let params:any = {};
    params.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    params.user_id = UserModule.getUserId;
    params.customer_id = customerId;
    getCustomerDetail(params).then(res => {
      if (res.data) {
        this.detailCustomer = res.data;
      } else {
        this.detailCustomer = '';
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private tabBeforeHandle(activeName: string, oldActiveName: string) {
    if (activeName === 'third') {
      let routeData = this.$router.resolve({
        path: '/Device/Device/toCustomer',
        query: this.detailCustomer
      });
      window.open(routeData.href);
      return false;
    }
    if (activeName === 'second') {
      let routeData = this.$router.resolve({
        path: '/Record/list',
        query: this.detailCustomer
      });
      window.open(routeData.href);
      return false;
    }
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
